import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "Pratik Chawla";

const TITLES = {
  "/": "",
  "/work": "Work",
  "/journal": "Journal",
  "/about": "About",
  "/contact": "Contact",
  "/fitness": "Fitness",
  "/fitness/engine": "The Engine",
  "/fitness/plan": "Plan",
  "/fitness/activities": "All Sessions",
  "/fitness/map": "Activity Map",
  "/fitness/health": "Health & Sleep",
  "/fitness/tennis": "Tennis",
  "/fitness/progress": "Streaks & Progress",
  "/studio": "Studio",
};

const setTitle = (name) => {
  document.title = name ? `${name} — ${SITE}` : SITE;
};

// detail pages (a project, a journal entry, a session) name themselves
export const useTitle = (name) => {
  useEffect(() => {
    if (name) setTitle(name);
  }, [name]);
};

const usePageTitle = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const name = TITLES[pathname];
    if (name !== undefined) setTitle(name);
    else if (!/^\/(work|journal|fitness\/a)\/./.test(pathname)) setTitle("");
  }, [pathname]);
};

export default usePageTitle;
